import React from "react";
import { BsFillCaretRightFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const ListItem = ({ index, color, donation }) => {
  const { id, title, shortDes, authorTitle } = donation || {};
  const navigate = useNavigate();
  const navigateHandler = () => {
    navigate(`/donation/${id}/${title}`);
  };
  return (
    <button
      onClick={navigateHandler}
      className={`text-left ${donation?.isDisable ? "text-gray-500" : ""} `}
      disabled={donation?.isDisable}
    >
      <div
        className={`ksm:pl-[40px] ksm:pr-[30px] ksm:py-[20px] kmd:pl-[60px] kmd:pr-[40px] kmd:py-[42px] klg:pl-[100px] klg:pr-[60px] klg:py-[62px] kxl:pl-[120px] kxl:pr-[80px] kxl:py-[100px] w-full ksm:rounded-[15px] kmd:rounded-[25px] kxl:rounded-[40px] grid grid-cols-9 items-center shadow-home-card cursor-pointer ${
          index % 2 === 0 ? "bg-custom-blue-400" : "bg-custom-blue-100"
        }`}
      >
        <div
          className="col-span-2 ksm:h-[40px] ksm:w-[40px] kmd:h-[80px] kmd:w-[80px] klg:h-[120px] klg:w-[120px]  kxl:h-[160px] kxl:w-[160px] rounded-full"
          style={{ backgroundColor: color }}
        ></div>
        <div className="col-span-6 px-10 border-l border-custom-gray-500">
          <p className="uppercase font-semibold text-black ksm:text-[20px] kmd:text-[24px] klg:text-[45px] kxl:text-[60px] ">
            {authorTitle}
          </p>
          <small className="ksm:text-sm kmd:text-md klg:text-lg kxl:text-2xl">
            {shortDes}
          </small>
        </div>
        <div
          className="col-span-1 rounded-full flex justify-end ksm:text-[40px] kmd:text-[50px] klg:text-[80px]"
          style={{ color: color }}
        >
          <BsFillCaretRightFill />
        </div>
      </div>
    </button>
  );
};

export default ListItem;
